import React, {useState, useContext} from 'react';
import './ProjectStateForm.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {ProjectsContext} from '../../contexts/projectsContext';
import {Button, TextInput} from '../_common';

const ProjectStateForm = ({primaryButtonAction, secondaryButtonAction}) => {
  const { t } = useContext(I18nContext);
  const {projectStatePending} = useContext(ProjectsContext);
  const [formValues, setFormValues] = useState({
    comment: ""
  });

  const changeValue = (name, value) => {
    const newValues = {...formValues};
    newValues[name] = value.id ? value.id : value;
    setFormValues(newValues);
  };

  const formHasEmptyFields = () => {
    const emptyOptionInputs = [
      formValues.comment
    ].filter(item => !item);
    return !!emptyOptionInputs.length;
  };

  return (
    <div className='ProjectStateForm'>
      <div className='formInputs'>
        <TextInput
          label={t('comment')}
          required
          name='comment'
          onChange={changeValue}
          value={formValues.comment}
        />
      </div>
      <div className='formButtons'>
        <Button type='secondary' action={secondaryButtonAction} label={t('cancel')} />
        <Button
          type='primary'
          action={() => primaryButtonAction(formValues.comment)}
          label={t('change project state')}
          margin='left'
          disabled={projectStatePending || formHasEmptyFields()}
          pending={projectStatePending}
        />
      </div>
    </div>
  );
};

export default ProjectStateForm;
